import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import _ from 'lodash'
import { Segment, Table, Statistic } from 'semantic-ui-react'

import OperatorReportActions from '../../reducers/operatorReportReducer'
import UserActions from '../../reducers/userReducer'
// import DownloadButton from './components/DownloadSheetButton'
import DateRangeField from './components/DateRangeField'
import { Grid } from 'semantic-ui-react'

const headers = ['User UUID', 'Name', 'Count', 'Ordered By Muuver', 'Ordered By Operator', 'Accept By Vendor']

class OperatorReport extends React.PureComponent {
  state = {
    startFrom: Number(
      moment()
        .startOf('month')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('month')
        .format('x')
    ),
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  getOrderByDate = () => {
    const { getOperatorReport } = this.props
    const { startFrom, endAt } = this.state

    getOperatorReport(startFrom, endAt)
  }

  onSearch = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.getOrderByDate()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  renderStatistics = orders => {
    const orderItems = [
      {
        key: 'All Orders',
        label: 'Orders',
        value: orders.length || 0,
        color: 'green',
      },
    ]

    return (
      <React.Fragment>
        <Grid size="equal">
          <Grid.Column>
            <Segment>
              <Statistic.Group items={orderItems} widths="one" size="small" />
            </Segment>
          </Grid.Column>
        </Grid>
        {/* <Grid size="equal" style={{ marginBottom: 14 }}>
          <Grid.Column>
            <Segment>
              <Statistic.Group items={voucherStatistic} widths="four" size="small" />
            </Segment>
          </Grid.Column>
        </Grid> */}
      </React.Fragment>
    )
  }

  renderRow = (orders, uid) => {
    const { users } = this.props
    const user = users.find(u => u.uid === uid)

    const { count, acceptByVendor, orderedByMuuver, orderedByOperator } =
      orders.length > 0 &&
      orders.reduce(
        (accum, order) => {
          accum.count += 1
          const { accepted_by = undefined, ordered_by } = order
          if (accepted_by && accepted_by.match(/(opt|operator)/i)) accum.acceptByVendor += 1
          // if (ordering_by === undefined && ordered_by === undefined) accum.orderingByMuuver += 1
          // if (accepted_by && accepted_by.match(/(muuver)/i))
          if (ordered_by === null) {
            accum.orderedByMuuver += 1
          } else {
            accum.orderedByOperator += 1
          }
          return accum
        },
        { count: 0, acceptByVendor: 0, orderedByMuuver: 0, orderedByOperator: 0 }
      )
    return (
      <Table.Row key={uid}>
        <Table.Cell textAlign="center">{Boolean(uid) ? uid : 'None'}</Table.Cell>
        <Table.Cell textAlign="center">{user ? user.username : 'No Assign User / Senior'}</Table.Cell>
        <Table.Cell textAlign="center">{count}</Table.Cell>
        <Table.Cell textAlign="center">{orderedByOperator}</Table.Cell>
        <Table.Cell textAlign="center">{orderedByMuuver}</Table.Cell>
        <Table.Cell textAlign="center">{acceptByVendor}</Table.Cell>
      </Table.Row>
    )
  }

  renderNoDataRow = () => {
    const { loading } = this.props
    return (
      <Table.Row>
        <Table.Cell colSpan={14} textAlign="center">
          {loading ? 'Loading' : 'No Data available'}
        </Table.Cell>
      </Table.Row>
    )
  }
  componentDidMount() {
    const { getAllUsers } = this.props
    getAllUsers()
  }

  render() {
    const { startFrom, endAt } = this.state
    const { orders, loading } = this.props

    const delivererOrders = this.groupOrderByDeliverer(orders)

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        <div style={{ padding: '0px 14px' }}>
          <DateRangeField
            loading={loading}
            startFrom={startFrom}
            endAt={endAt}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />
          <div style={{ marginBottom: 15 }} />
          {this.renderStatistics(orders)}
          <Table>
            <Table.Header>
              <Table.Row>
                {headers.map((header, index) => (
                  <Table.HeaderCell key={index} textAlign="center">
                    {header}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {_.keys(delivererOrders).length > 0
                ? _.map(delivererOrders, this.renderRow)
                : this.renderNoDataRow()}
            </Table.Body>
          </Table>
        </div>
      </Segment>
    )
  }
  groupOrderByDeliverer = orders => _.groupBy(orders, order => order.current_operator)
}

const mapState = ({ operatorReport }) => ({
  users: operatorReport.users,
  orders: operatorReport.data,
  loading: operatorReport.loading,
})

const mapDispatch = {
  getOperatorReport: OperatorReportActions.getOperatorReport,
  getAllUsers: UserActions.getAllUsers,
}

export default connect(
  mapState,
  mapDispatch
)(OperatorReport)



// WEBPACK FOOTER //
// ./src/containers/reports/operator.js